const menuAboutES = {
    "view": {
        "label": {
            "myProfile": "Mi Perfil",
            "twoFactorAuthentication": "Autenticación de Dos Factores",
            "mySubscription": "Mi Suscripción",
            "announcements": "Anuncios",
            "mySubUsers": "Mis Sub-Usuarios",
            "myLabels": "Mis Sellos",
            "escrowWallet": "Billetera de Depósito",
            "copyright": "Infracciones de Derechos de Autor",
            "financialStatements": "Estados Financieros",
            "userStatements": "Estados de Usuario",
            "subuserStatements": "Estados de Subusuario",
            "invoices": "Facturas",
            "paymentMethods": "Métodos de Pago",
            "purchaseHistory": "Historial de Compras",
            "accessKeys": "Claves de Acceso",
            "logout": "Cerrar Sesión"
        }
    }
};

export default menuAboutES;